module.exports = __webpack_public_path__ + "img/24.59022785.jpg";